import PasswordRestore from "./PasswordRestore"

export default PasswordRestore;